window.addEventListener("DOMContentLoaded", function () {
    searchDrawer();
});


function searchDrawer() {
    document.querySelectorAll(".js-search-header").forEach(btn => {
    btn.addEventListener('click', function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        document.dispatchEvent(new CustomEvent('predictive-search:open', {
        detail: {
            context: 'header'
        },
        bubbles: true
        }));

        // add is-active class to .site-header__search-container
        document.querySelector(".site-header__search-container").classList.add('is-active');
    });
    });

    document.addEventListener('predictive-search:close-all', function() {
    closeSearchDrawer();
    });
}

function closeSearchDrawer(evt) {
    // Do not close if click event came from inside drawer
    if (evt) {
    // evt.path is non-standard, so have fallback
    var path = evt.path || (evt.composedPath && evt.composedPath());
    for (var i = 0; i < path.length; i++) {
        if (path[i].classList) {
        if (path[i].classList.contains('site-header__search-btn')) {
            break;
        }

        if (path[i].classList.contains('site-header__search-container')) {
            return;
        }
        }
    }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    document.documentElement.classList.add('js-drawer-closing');
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');

    window.setTimeout(function() {
    document.documentElement.classList.remove('js-drawer-closing');
    }.bind(this), 500);

    var container = document.querySelector(".site-header__search-container");
    container.setAttribute("aria-modal", "true");
    theme.utils.prepareTransition(container, function() {
    container.classList.remove('is-active');
    document.documentElement.style.overflow = '';
    }.bind(this));
}

